import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ButtonProps } from '@nuxt/ui'
import type { PresetName } from 'seslen/presets'
import type { ButtonMotionPreset, NamedButtonPreset } from '~/composables/buttonMotion'
import { m } from 'motion-v'
import { createButtonMotion } from '~/composables/buttonMotion'

type MotionButtonSize = ButtonProps['size'] | '2xl' | '3xl' | '4xl'


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'MMotionButton',
  props: {
    preset: {},
    block: { type: Boolean, default: false },
    long: { type: Boolean, default: false },
    size: {},
    sound: { type: [String, Boolean], default: 'tick' },
    icon: {}
  },
  setup(__props: any) {



// eslint-disable-next-line vue/require-valid-default-prop -- compiler-derived runtime defaults can't infer the union with `false`


const { getRandomPreset, getNamedPreset } = createButtonMotion()
const motionPreset: ButtonMotionPreset = __props.preset ? getNamedPreset(__props.preset) : getRandomPreset()

const { play } = useSound()
const MotionDiv = m.div

const wrapperClass = computed(() => {
  if (__props.block)
    return 'flex w-full'
  return 'inline-flex max-w-full'
})

function onPress() {
  if (__props.sound)
    play(__props.sound, { throttle: 60, rateJitter: 0.04 })
}
function onHover() {
  // Near-silent puff for hover affordance, throttled hard so a row of
  // buttons doesn't sound like a swarm.
  play('hover', { throttle: 120, gain: 0.75, rateJitter: 0.05 })
}

return (_ctx: any,_cache: any) => {
  const _component_UButton = _resolveComponent("UButton")!

  return (_openBlock(), _createBlock(_unref(MotionDiv), {
    class: _normalizeClass(_unref(wrapperClass)),
    "while-hover": _unref(motionPreset).whileHover,
    "while-press": _unref(motionPreset).whilePress,
    transition: _unref(motionPreset).transition,
    onClick: onPress,
    onHoverStart: onHover
  }, {
    default: _withCtx(() => [
      _createVNode(_component_UButton, _mergeProps(_ctx.$attrs, {
        icon: __props.icon,
        block: __props.block,
        long: __props.long,
        size: __props.size,
        class: "cursor-pointer"
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["icon", "block", "long", "size"])
    ]),
    _: 3
  }, 8, ["class", "while-hover", "while-press", "transition"]))
}
}

})